module.exports = __webpack_public_path__ + "static/img/fgbg1-11.7011118.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/fgbg1-11.png
// module id = 189
// module chunks = 0